<template>
  <section>
    <Header
      v-on:user-details="user => addLoggedInDetails(user)"
      :page="page"
      :name="fname"
    />

    <!-- empty div for content to show below navbar -->
    <div style="height: 64px;"></div>

    <!-- <span>{{$route.params}}</span> -->

    <section class="main">
      <div class="container py-5 py-md-3 pt-md-5">
        <div class="purchase">
          <!-- left box (conditionally rendered as per page number) -->
          <select-box
            v-if="page==0"
            v-on:select="selected => this.selected=selected"
            v-on:proceed="proceed()"
            :courses="courses"
          />
          <section v-else-if="page==1">
            <delivery-box
              v-on:personal="data => setPersonalData(data)"
              v-on:name="name => this.fname=name"
              :is-logged-in="isLoggedIn"
              :user="{
                fname,
                lname,
                phone,
                email,
                pin,
              }"
            />
            <review :enabled="false" class="mt-3" />
          </section>

          <section v-else-if="page==2">
            <delivery-otp
              v-on:otp="setOtp()"
              :phone="phone"
              :is-logged-in="isLoggedIn"
            />
            <review :enabled="false" class="mt-3" />
          </section>

          <section v-else-if="page==3">
            <delivery-address
              v-on:address="address => addAddress(address)"
              :fname="fname"
              :lname="lname"
              :phone="phone"
              :email="email"
              :address-required="selectedCourseDetail.addressRequired"
              v-on:skip="page++"
            />
            <review :enabled="false" class="mt-3" />
          </section>

          <section v-else-if="page==4">
            <delivery-disabled
              :fname="fname"
              :lname="lname"
              :phone="phone"
              :email="email"
            />
            <review
              v-on:remove="page=0;selectedCourseDetail={}; selected=undefined"
              v-on:proceed-to-buy="proceedToBuy()"
              :enabled="true"
              class="mt-3"
              :course="selectedCourseDetail"
            />
          </section>

          <div class="box right">
            <div :class="[summary ? '' : 'hidden', 'box cart-items']">
              <div class="header px-4 px-lg-3">
                <h2 class="my-auto d-flex justify-content-center">
                  <span v-if="page==0" class="mr-3">Selected Courses</span>
                  <span v-else class="mr-3">
                    <span style="font-size: 14px;" class="d-md-none">
                      Total Payable
                      <span style="color: #909090; font-weight: 300;" class="ml-2">
                        <small style="font-size: 13px;" v-if="selected !== undefined">(1 course)</small>
                        <small style="font-size: 13px;" v-else>(0 course)</small>
                      </span>
                    </span>
                    <div style="font-size: 24px; font-weight: 700; color: #303030;" class="d-md-none text-left">
                      &#8377; {{ selectedCourseDetail.price ? selectedCourseDetail.price.toLocaleString() : 0 }}
                    </div>
                    <span class="d-none d-md-inline">
                      Order Summary
                    </span>
                  </span>
                  <!-- <h3>Rs. 1233</h3> -->
                </h2>
                <span class="d-none d-md-inline">
                  <small style="font-size: 13px;" v-if="selected !== undefined">(1 course)</small>
                  <small style="font-size: 13px;" v-else>(0 course)</small>
                </span>
                <button @click="summary=!summary" class="ml-auto d-md-none" style="background: inherit; border: none; outline: none;">
                  <svg :class="[summary ? 'rotater' : 'not-rotater']" width="13" height="9" viewBox="0 0 13 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.70687 0.786133L6.29687 5.38825L10.8869 0.786133L12.2969 2.20294L6.29687 8.23192L0.296875 2.20294L1.70687 0.786133Z" fill="black" fill-opacity="0.54"/>
                  </svg>
                </button>
              </div>
              <div class="right-content">
                <div class="right-content-card text-left px-3 mt-3" v-if="selectedCourseDetail && selectedCourseDetail.name">
                  <img
                    :src="selectedCourseDetail.image"
                    alt="Thumbnail"
                    height="50"
                  >
                  <div class="mx-1" style="font-size: 14px; max-width: 147px;">
                    {{ selectedCourseDetail.name }}
                  </div>
                  <div style="font-size: 14px;">
                    <b style="display: inline-block; min-width: 60px;">
                      &#8377; {{ selectedCourseDetail.price ? selectedCourseDetail.price.toLocaleString() : 0 }}
                    </b>
                  </div>
                </div>
              </div>
              <div class="right-footer">
                <div class="inner px-4">
                  <span>
                    Total Payable
                  </span>
                  <b>
                    &#8377; {{ (selectedCourseDetail && selectedCourseDetail.price) ? selectedCourseDetail.price.toLocaleString() : 0 }}
                  </b>
                </div>
              </div>
            </div>
          </div>

          <div v-if="page!==0" style="height: 60px;" class="numbering d-md-none container">
            <div class="one-two d-flex d-md-none justify-content-between align-items-center">
              <div class="one number-box">
                <div v-if="page>3" class="number disabled">
                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.21493 8.13903C3.86535 8.2891 3.44452 8.21087 3.17335 7.91423L0.907855 5.43592C0.565183 5.06106 0.591278 4.47939 0.966139 4.13671C1.341 3.79404 1.92268 3.82013 2.26535 4.19499L3.91058 5.99477L9.79369 0.61684C10.1685 0.274167 10.7502 0.300262 11.0929 0.675123C11.4356 1.04998 11.4095 1.63166 11.0346 1.97433L4.4734 7.97215C4.39494 8.04387 4.30742 8.09944 4.21493 8.13903Z" fill="white"/>
                  </svg>
                </div>
                <div v-else class="number enabled">
                  1
                </div>
                <div class="text">Delivery Information</div>
              </div>
              <div class="two number-box">
                <div :class="[page<4 ? 'disabled' : 'enabled', 'number']">
                  2
                </div>
                <div class="text">Review &amp; Pay</div>
              </div>
            </div>
          </div>
        </div>

        <!-- footer -->
        <div class="footer">
          <hr />
          <footer>
            <p>&copy; Copyright 2008-2020 Avishkaar.cc</p>
            <p>
              Need Help? Write to us at <a href="mailto:support@avishkaar.cc">support@avishkaar.cc</a> or <a href="tel:+918506931515">Call at +91 8506931515</a>
            </p>
          </footer>
        </div>
      </div>
    </section>

    <!-- <Footer /> -->
  </section>
</template>

<script>
// import { mapGetters, mapActions } from "vuex";
import { mapActions } from "vuex";
// header
import Header from '@/components/Bbc/Header.vue';

import SelectBox from '../components/Bbc/SelectBox.vue';
import DeliveryBox from '../components/Bbc/DeliveryBox.vue';
import DeliveryOtp from '../components/Bbc/DeliveryOtp.vue';
import DeliveryAddress from '../components/Bbc/DeliveryAddress.vue';
import DeliveryDisabled from '../components/Bbc/DeliveryDisabled.vue';
import Review from '../components/Bbc/Review.vue';
// import func from 'vue-editor-bridge';

import axios from "axios";

export default {
  name: 'BuyBbc',
  components: {
    Header,
    SelectBox,
    DeliveryBox,
    DeliveryOtp,
    DeliveryAddress,
    DeliveryDisabled,
    Review,
  },
  data() {
    return {
      // BASE_URL: process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "",
      BASE_URL: process.env.NODE_ENV === "production" ? process.env.VUE_APP_API_URL : "",
      courses: [],
      selected: undefined,
      selectedCourseDetail: {},
      summary: false,
      page: 0,
      isLoggedIn: false,

      // personal details
      fname: '',
      lname: '',
      phone: '',
      email: '',
      
      otp: '',

      // address details
      address1: '',
      address2: '',
      city: '',
      state: '',
      pin: '',
    }
  },
  methods: {
    ...mapActions(["addGuestUserCartDetail","addGuestuser","sendOTP","addUserAddress","checkPincode"]),

    proceed() {
      // console.log(this.selectedCourseDetail)
      this.page++;
    },

    addLoggedInDetails(user) {
      this.isLoggedIn = true;
      this.fname = user.first_name;
      this.lname = user.last_name;
      this.phone = user.phone.substring(3, 13);
      this.email = user.email;
      this.pin = user.pincode ? user.pincode : '';
      // console.log(this.phone);
    },

    // save user data to db
    setPersonalData(data) {
      this.fname = data.fname;
      this.lname = data.lname;
      this.phone = data.phone;
      this.email = data.email;
      this.pin = data.pin;

      this.page++;
    },
    setOtp() {
      // send guest user details
      if (!this.isLoggedIn) {
        const guestUserPayload = {
          "first_name": this.fname,
          "last_name": this.lname,
          "email": this.email,
          "source": `avishkaar.cc${this.$route.fullPath}`,
          "phone": `+91${this.phone}`,
          // "pincode": data.pin,
        }
        // console.log(guestUserPayload);
        // this.addGuestuser(guestUserPayload)
        axios.post(`${this.BASE_URL}/purchase/club/guest`,guestUserPayload)
        .then(res => {
          this.$cookies.set("guestAccess", res.data.token)
          this.page++;
        });
      }
      // ----
      else this.page++;
    },
    addAddress(address) {
      this.address1 = address.address1;
      this.address2 = address.address2;
      this.city = address.city;
      this.state = address.state;
      // this.pin = address.pin;

      // const guestUserPayload = {
      //   "first_name": this.fname,
      //   "last_name": this.lname,
      //   "email": this.email,
      //   "phone_no": this.phone,
      //   "pincode": address.pin,
      // }
      // this.addGuestuser(guestUserPayload)

      // save user address to db
      const address_payload = {
        name: this.fname,
        phone: this.phone,
        address_line1: address.address1,
        address_line2: address.address2 ? address.address2 : '',
        city: address.city,
        state: address.state,
        pincode: this.pin,
      }
      this.addUserAddress(address_payload)
      .then(() => {
        // console.log(res)
        this.page++;
      })
      // ----

    },
    proceedToBuy() {
      // axios.post(`${this.BASE_URL}/purchase/club/${this.$route.params.token}/${this.selectedCourseDetail.product_code}`)
      // .then(res => {
      //   console.log(res.data.status)
        // alert(process.env.VUE_APP_SITE_URL+'/club/purchase/process-request?token='+this.$route.params.token+"&code="+this.selectedCourseDetail.product_code);
        this.$cookies.set('clubPurchase', `${this.$route.params.token} ${this.selectedCourseDetail.product_code}`)
        window.location = process.env.VUE_APP_SITE_URL+'/club/purchase/process-request';
      // })
    }
  },
  created() {
    fetch(`${this.BASE_URL}/purchase/club/${this.$route.params.token}`)
    .then(res => (res.json()))
    .then(data => data.data.items.forEach(c => {
      this.courses.push({
        image: c.image,
        name: c.product_name,
        price: c.deal_price,
        description: c.description,
        product_code: c.product_code,
        addressRequired: c.address_required,
      });
    }));
  },
  watch: {
    selected : function() {
      this.selectedCourseDetail = this.courses[this.selected];
    },
  }
}
</script>

<style>
  /* numbering on mobile */
  .numbering {
    position: relative;
  }
  .numbering::before {
    content: '';
    position: absolute;
    border-top: solid 2px #e0e0e0;
    width: 35%;
    top: 11px;
    left: 33%;
  }
  .numbering > .one-two > .number-box {
    height: 50px;
    width: 50%;
    color: #909090;
    background: #f5f5f5;

    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .numbering > .one-two > .number-box > .number {
    height: 24px;
    width: 24px;
    color: #fff;
    border-radius: 1000px;
  }

  .numbering > .one-two > .number-box > .number.enabled {
    background: #F36F2E;
  }
  .numbering > .one-two > .number-box.one > .number.disabled {
    background: #9FC349;
  }
  .numbering > .one-two > .number-box > .number.disabled {
    background: #c0c0c0;
  }

  .numbering > .one-two > .number-box > .number.enabled  ~ .text {
    color: #F36F2E;
  }
  .numbering > .one-two > .number-box > .number.disabled  ~ .text {
    color: #909090;
  }
  /* ---- */

  /* main grey section */
  section.main {
    background: #f5f5f5;
    min-height: calc(100vh - 64px);
    width: 100vw;
    position: relative;
  }

  section.main > .container {
    min-height: calc(100vh - 64px);
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  @media screen and (max-width: 576px) {
    section.main > .container {
      padding-left: 0;
      padding-right: 0;
    }
  }
  @media screen and (max-width: 576px) {
    section.main > .container {
      min-height: calc(100vh - 64px);
    }
  }
  @media screen and (min-width: 577px) and (max-width: 1024px) {
    section.main > .container {
      min-height: calc(100vh - 64px);
    }
  }

  /* course selection section */
  section.main > .container > .purchase {
    display: flex;
    justify-content: center;
    gap: 30px;
    /* min-height: 80vh; */
  }

  /* individual boxes */
  @media screen and (min-width: 577px) and (min-width: 768px) {
    section.main > .container > .purchase  .left-box-sizing {
      width: 100%;
    }
  }
  @media screen and (min-width: 769px) {
    section.main > .container > .purchase  .left-box-sizing {
      width: 700px;
    }
  }
  section.main > .container > .purchase > .box > .cart-items {
    /* width: 30%; */
    overflow: hidden;
    transition: height 0.4s;
  }
  section.main > .container > .purchase > .box.right {
    width: 30%;
  }
  @media screen and (max-width: 576px) {
    section.main > .container > .purchase > .box.right {
      width: 100%;
    }
  }
  @media screen and (max-width: 576px) {
    section.main > .container > .purchase > .box > .cart-items.hidden {
      height: 84px;
      overflow: hidden;
    }
  }

  /* rotate the cart arrow on click */
  .rotater {
    transform: rotate(180deg);
    transition: transform 0.4s;
  }
  .not-rotater {
    transform: rotate(0deg);
    transition: transform 0.4s;
  }
  /* ---- */

  /* reverse and widen boxes on small screens */
  @media screen and (max-width: 576px) {
    section.main > .container > .purchase {
      flex-direction: column-reverse;
      align-items: center;
  }
    section.main > .container > .purchase > .left-box-sizing {
      width: 100%;
    }
    section.main > .container > .purchase > .cart-items {
      width: 100%;
    }
  }

  /* styling to boxes */
  section.main > .container .purchase .box {
    background: #FFFFFF;
    box-sizing: border-box;
    border-radius: 10px;
    min-height: 84px;
  }
  section.main > .container > .purchase .orange {
    border: 2px solid #F36F2E;
  }
  section.main > .container > .purchase .grey {
    border: 2px solid #E0E0E0;
  }
  /* remove border curve on mobile */
  @media screen and (max-width: 576px) {
    section.main > .container .purchase .box {
      border-radius: 0;
    }
    section.main > .container > .purchase .orange {
      border: none;
    }
    section.main > .container > .purchase .grey {
      border: none;
    }
  }

  section.main > .container > .purchase > :not(.orange) {
    /* height: 320px; */
    background: inherit;
    border-radius: 0;
  }
  .cart-items {
    height: 320px;
  }
  @media screen and (min-width: 768px) and (max-width: 1024px) {
    .cart-items {
      height: auto;
      min-height: 320px;
    }
  }

  /* styling to header of boxes */
  section.main > .container > .purchase .box > .header {
    height: 84px;
    display: flex;
    justify-content: left;
    align-items: center;
  }
  
  section.main > .container > .purchase .box > .header > h2 {
    font-weight: 500;
    font-size: 18px;
    color: #373737;
    margin: auto 0;
  }
  
  section.main > .container > .purchase .box > .header > h2 > small {
    display: block;
    font-size: 12px;
  }

  /* styling to content of boxes */
  section.main > .container > .purchase .box > .content {
    /* height: 256px; */
    border-top: solid 1px #dcdcdc;
    border-bottom: solid 1px #dcdcdc;
    overflow-y: auto;
    /* padding-left: 4px; */
    /* padding-top: 20px; */
    /* cursor: pointer; */
  }

  /* styling scrollbar */
  section.main > .container > .purchase .box > .content::-webkit-scrollbar {
    width: 6px;
    background: #fff;
  }
  section.main > .container > .purchase .box > .content::-webkit-scrollbar:hover {
    background: #eee;
  }
  section.main > .container > .purchase .box > .content::-webkit-scrollbar-thumb {
    width: 4px;
    background: rgba(0, 0, 0, 0.1);
    border-radius: 9.5px;
  }

  /* content options */
  section.main > .container > .purchase .box > .content > .option {
    height: 64px;
    cursor: pointer;
  }
  section.main > .container > .purchase .box > .content > .option:hover {
    background: #fff9ea;
  }

  section.main > .container > .purchase .box > .content > .option > .input-group {
    height: 64px;
    display: flex;
    align-items: center;
    position: relative;
  }

  section.main > .container > .purchase .box > .content > .option:first-child {
    margin-top: 20px;
  }

  section.main > .container > .purchase .box > .content > .option > .input-group .price {
    font-size: 16px;
    font-weight: 600;
    margin-right: 10px;
  }

  section.main > .container > .purchase .box > .content > .option > .input-group > label {
    justify-content: left !important;
  }

  section.main > .container > .purchase .box > .content > .option > .input-group > label > .course-name {
    font-size: 14px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    /* width: 250px; */
    margin-left: 10px !important;
    margin-right: auto;
  }
  @media screen and (max-width: 576px) {
    section.main > .container > .purchase .box > .content > .option > .input-group > label > .course-name {
      width: 180px;
    }
  }
  @media screen and (min-width: 768px) and (max-width: 1000px) {
    section.main > .container > .purchase .box > .content > .option > .input-group > label > .course-name {
      width: 220px;
    }
  }

  section.main > .container > .purchase .box > .content > .option > .input-group > input[type=radio]:checked ~ label {
    background: #fff3db;
  }

  /* styling radio button as per avishkaar orange */
  section.main > .container > .purchase .box > .content > .option > .input-group > input[type=radio] {
    height: 0;
    width: 15%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  section.main > .container > .purchase .box > .content > .option > .input-group > input[type=radio]::before {
    content: '';
    display: inline-block;
    height: 11px;
    width: 11px;
    border: solid 1px #F36F2E;
    border-radius: 1000px;
    /* margin-left: 50%; */
    background: #fff;
    position: absolute;
  }
  section.main > .container > .purchase .box > .content > .option > .input-group > input[type=radio]:checked::after {
  content: '';
  display: inline-block;
  height: 7px;
  width: 7px;
  background: #F36F2E;
  position: absolute;
  /* top: 4px;
  left: 2px; */
  /* right: calc(50%-7px); */
  /* top: -5px; */
  border-radius: 1000px;
  }
  /* @media screen and (max-width: 576px) {
    section.main > .container > .purchase .box > .content > .option > .input-group > input[type=radio]:checked::after {
      height: 8px;
      width: 8px;
      top: -4.4px;
    }
  } */

  section.main > .container > .purchase .box > .content > .option > .input-group > label {
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding-left: 15%;
  }

  /* styling to footer of boxes */
  section.main > .container > .purchase .box > .footer {
    min-height: 84px;
  }

  section.main > .container > .purchase .box > .footer > .form {
    min-height: 84px;
    display: flex;
    justify-content: center;
    align-items: center;
  } 

  section.main > .container > .purchase .box > .footer > .form > input {
    height: 42px;
    width: 240px;
    background-color: #F36F2E;
    border-radius: 1000px;
  } 
  section.main > .container > .purchase .box > .footer > .form > input:disabled {
    background: #e0e0e0;
    cursor: default;
  }

  /* styling right box */
  section.main > .container > .purchase .box > .box > .right-content {
    border-top: solid 1px #dcdcdc;
    border-bottom: solid 1px #dcdcdc;
    min-height: 152px;
  }
  
  section.main > .container > .purchase .box > .box > .right-content > .right-content-card {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  /* section.main > .container > .purchase > .box > .right-content > .right-content-card > img {} */

  section.main > .container > .purchase .box > .box > .right-footer {
    min-height: 84px;
  }
  section.main > .container > .purchase .box > .box .right-footer > .inner {
    min-height: 84px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* bottom footer section */
  section.main > .container > .footer > footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    /* position: -webkit-sticky;
    position: sticky;
    bottom: 20px; */
  }
  @media screen and (max-width: 768px) {
    section.main > .container > .footer {
      margin-top: 60px;
    }
    section.main > .container > .footer > footer {
      justify-content: center;
      flex-direction: column;
    }
  }
  section.main > .container > .footer > footer > p {
    color: #909090;
  }
  section.main > .container > .footer > footer a {
    text-decoration: none;
    color: #909090;
    font-weight: bold;
  }
</style>

<style>
body {
  overflow-x: hidden;
}
/* styling error message */
.input-error {
  font-size: 0.6rem;
}
</style>

<style>
  /* remove increase, decrease buttons from <input type="number"> */
  input[type=number]::-webkit-inner-spin-button, 
  input[type=number]::-webkit-outer-spin-button { 
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      margin: 0; 
  }
</style>